import React from 'react';
import { CHINESE, CHINESE_HK, ENGLISH } from '../../utils/constants';
import { Button, Dropdown, Menu } from 'antd';

class Select extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      languageVal: '简体中文'
    };
  }

  render() {
    const { intl, locale, dispatch } = this.props.data;
    let language = intl.locale;
    const changeLanguage = ({ key }) => {
      let keyValue = key.split('--');
      if (keyValue[1] === '1') {
        language = CHINESE;
        this.setState({ languageVal: '简体中文' });
      } else if (keyValue[1] === '2') {
        language = CHINESE_HK;
        this.setState({ languageVal: '繁體中文' });
      } else if (keyValue[1] === '3') {
        language = ENGLISH;
        this.setState({ languageVal: 'English' });
      }
      dispatch({
        type: 'menu/shiftLanguage',
        locale: language
      });
    };
    const menu = (
      <Menu onClick={changeLanguage} style={{width:'10rem'}}>
        <Menu.Item
          key={intl.formatMessage({ id: 'index_language_chinese' }) + '--' + 1}>
          <div rel="noopener noreferrer">
            {intl.formatMessage({ id: 'index_language_chinese' })}
          </div>
        </Menu.Item>
        <Menu.Item
          key={intl.formatMessage({ id: 'index_language_chineseHk' }) + '--' + 2}>
          <div rel="noopener noreferrer">
            {intl.formatMessage({ id: 'index_language_chineseHk' })}
          </div>
        </Menu.Item>
        <Menu.Item
          key={intl.formatMessage({ id: 'index_language_english' }) + '--' + 3}>
          <div rel="noopener noreferrer">
            {intl.formatMessage({ id: 'index_language_english' })}
          </div>
        </Menu.Item>
      </Menu>
    );

    return (
      <Dropdown overlay={menu} placement="bottomLeft">
        <Button>
          {intl.locale === CHINESE ? this.state.languageVal :
            intl.locale === CHINESE_HK ? intl.formatMessage({ id: 'index_language_chineseHk' }) :
              intl.formatMessage({ id: 'index_language_english' })
          }
        </Button>
      </Dropdown>
    );
  }
}

export default Select;
                         



// WEBPACK FOOTER //
// ./src/components/layout/select.js